import $ from "jquery";
import React from "react";
import PropTypes from "prop-types";

// Libraries for buttons
import * as JSZip from "jszip";
import { useEffect } from "react";
window.JSZip = JSZip;

import "pdfmake/build/pdfmake.js";
import "pdfmake/build/vfs_fonts.js";
// Datatables
import "datatables.net-bs";
import "datatables.net-bs4/js/dataTables.bootstrap4.js";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
import "datatables.net-buttons";
import "datatables.net-buttons-bs";
import "datatables.net-responsive";
import "datatables.net-responsive-bs";
import "datatables.net-responsive-bs/css/responsive.bootstrap.css";
import "datatables.net-buttons/js/buttons.colVis.js"; // Column visibility
import "datatables.net-buttons/js/buttons.html5.js"; // HTML 5 file export
import "datatables.net-buttons/js/buttons.flash.js"; // Flash file export
import "datatables.net-buttons/js/buttons.print.js"; // Print view button
import "datatables.net-keytable";
import "datatables.net-keytable-bs/css/keyTable.bootstrap.css";

/**
 * Wrapper component for dataTable plugin
 * Only DOM child elements, componets are not supported (e.g. <Table>)
 */
const Datatable = ({ children, options, dtInstance }) => {
    let tableElement;

    useEffect(() => {
        const tableInstance = $(tableElement).DataTable(options);

        if (dtInstance) dtInstance(tableInstance);

        return () => $(tableElement).DataTable({ destroy: true });
    }, []);

    const setRef = (node) => (tableElement = node);

    return React.cloneElement(React.Children.only(children), {
        ref: setRef,
    });
};

Datatable.propTypes = {
    /** datatables options object */
    options: PropTypes.object,
    /** only one children allowed */
    children: PropTypes.element.isRequired,
    /** callback that receives the datatable instance as param */
    dtInstance: PropTypes.func,
};

Datatable.defaultProps = {
    options: {},
};

export default Datatable;
